import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { usePromotionForm } from '@/sections/promotion';
import Iconify from '@/components/Iconify';

function PromotionButton({ rounded = false }) {
  const { t } = useTranslation();
  const { promotions, clearPromotion, open } = usePromotionForm();

  return (
    <>
      {promotions?.code && (
        <Button
          variant={rounded ? 'contained-rounded' : 'contained'}
          size="medium"
          onClick={() => {
            clearPromotion();
          }}
          sx={{ 'background': '#139E65', '&:hover': { background: '#129D60' } }}
          startIcon={<Iconify width={14} height={14} icon={'mdi:tag'} />}
          endIcon={
            <Iconify
              width={18}
              height={18}
              icon={'carbon:close-filled'}
              sx={{ ml: 1 }}
            />
          }
        >
          {promotions.code}
        </Button>
      )}
      {!promotions?.code && (
        <Button
          variant={rounded ? 'outlined-rounded' : 'outlined'}
          size="medium"
          onClick={() => {
            open();
          }}
          color="primary"
          startIcon={<Iconify width={14} height={14} icon={'mdi:tag'} />}
        >
          {t('checkout.buttons.activeCoupon')}
        </Button>
      )}
    </>
  );
}

export default PromotionButton;
